var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page swap-forum"},[_c('iframe',{attrs:{"id":"show-iframe","src":_vm.SplicingUrl,"frameborder":"0","scrolling":"auto"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }